import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  videoSpace: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    video: {
      objectFit: 'cover'
    }
  },
  videoContainer: (isHover = false) => ({
    position: isHover ? 'absolute' : 'relative',
    opacity: isHover ? 0 : 1,
    ...reusables.mainTransition('opacity', theme.transitions.animation.atomCurve, theme.transitions.time.normal),
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pb: '100%',
    div: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      video: {
        objectFit: 'cover'
      }
    }
  })
};